import { useEffect, useRef, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import Router, { useRouter } from 'next/router';
import get from 'lodash/get';
import { styled } from '@nx-kit/styling';
import { cleanRouterQuery } from 'helpers/url';
//import { BreakpointContext } from 'contexts/breakpoint/BreakpointContext';
// import { ResultsCounterStyled, SortGroupStyled } from 'components/molecules/FilterRows';
import ComponentsRenderer from 'components/templates/partials/ComponentsRenderer';
// import { CtaDropdown } from 'components/molecules/CtaDropdown';
import { Breadcrumb } from 'components/molecules/Breadcrumb';
import { Separator } from 'components/organisms/Separator';
import { CourseBox } from 'components/molecules/CourseBox';
import Container from 'components/layout/Grid/Container';
import Column from 'components/layout/Grid/Column';
import { Loading } from 'components/atoms/Loading';
import { FilterSearchPageHeading } from 'components/molecules/FilterSearchPageHeading';
import { RowSortStyled } from 'components/molecules/FilterRows';
import { OverviewKurseProps } from './OverviewKurse.types';

export const RowGridStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const OverviewKurse: React.FC<OverviewKurseProps> = ({ data, courses, sharedSlices }) => {
  const router = useRouter();
  //const bp = useContext(BreakpointContext);
  //const isMobile = bp === 'xs' || bp === 'sm';
  const { t } = useTranslation('common');
  const [isloading, setIsLoading] = useState(false);

  const computedGridItems = () => {
    if (Array.isArray(courses)) {
      return courses;
    }
    return [];
  };

  const scrolledRef = useRef(false);

  useEffect(() => {
    const start = () => {
      setIsLoading(true);
    };
    const end = () => {
      setIsLoading(false);
    };

    const queryObj = cleanRouterQuery(router.query);
    if (queryObj.ref) {
      const elements = document.querySelectorAll(`[data-anlass="${queryObj.ref}"]`);
      if (elements && elements.length > 0) {
        elements[0].scrollIntoView({ behavior: 'smooth' });
        scrolledRef.current = true;
      }
    }

    Router.events.on('routeChangeStart', start);
    Router.events.on('routeChangeComplete', end);
    Router.events.on('routeChangeError', end);
    return () => {
      Router.events.off('routeChangeStart', start);
      Router.events.off('routeChangeComplete', end);
      Router.events.off('routeChangeError', end);
    };
  }, []);

  // 🔻 Gjithçka që ka lidhje me "Sortieren nach" ose "23 Kurse" është komentuar
  /*
  const isSortSelected = (): string => {
    const queryObj = cleanRouterQuery(router.query);
    const querySort = queryObj.sort;
    const singleQueryCat = Array.isArray(querySort) ? querySort[0] : querySort;
    return singleQueryCat || '';
  };

  const sortOptions = [
    {
      label: t('sortDateAsc'),
      value: 'asc',
    },
    {
      label: t('sortDateDes'),
      value: 'desc',
    },
  ];

  const onClickSort = (value: string): void => {
    const queryObj = cleanRouterQuery(router.query);
    if (value) {
      queryObj.sort = value;
    }
    const queryString = mapObjectToQueryString(queryObj);
    router.push(`/${lang}${router.asPath.split('?')[0]}${queryString}`, undefined);
  };

  const rowNumItemsComponent = (
    <ResultsCounterStyled style={{ display: 'none' }}>
      {courses.length || 0} {t('coursesNumResult')}
    </ResultsCounterStyled>
  );

  const sortSelectionComponent = (
    <SortGroupStyled>
      {t('sortBy')}
      <CtaDropdown
        options={sortOptions}
        defaultValue={isSortSelected()}
        onSelectCallback={(value) => {
          onClickSort(value);
        }}
      />
    </SortGroupStyled>
  );
  */

  return (
    <>
      <Container>
        <Column span={12}>
          <Breadcrumb />
        </Column>
      </Container>

      <Container>
        <Column span={12}>
          <FilterSearchPageHeading slices={get(data, 'data.body', [])} />

          {get(data, 'data.body', []).map((slice: any, index: number) => {
            console.log('Slice type:', slice.slice_type);

            if (
              slice.slice_type === 'kurse_sammlung' ||
              slice.slice_type === 'kurse_sammlung_legacy'
            ) {
              const titleText = slice?.primary?.title?.[0]?.text || '';

              return (
                <div key={`slice_${index}`} style={{ marginTop: '40px', marginBottom: '20px' }}>
                  <h2 style={{ marginTop: '40px', marginBottom: '20px' }}>{titleText}</h2>
                </div>
              );
            }

            return null;
          })}

          {/* Rreshti i mëparshëm i sortimit është hequr */}
          <RowSortStyled />

          <RowGridStyled>
            {computedGridItems().map((courseItem, index: number) => {
              return <CourseBox key={`course_${index}`} data={courseItem} />;
            })}
          </RowGridStyled>

          {isloading && <Loading />}
          {!isloading && !courses && <div>{t('noResults')}</div>}
          {courses.length === 0 && !isloading && <div>{t('noResults')}</div>}
        </Column>
      </Container>

      <Separator primary={{ horizontal_line: true }} />
      <ComponentsRenderer withoutWrapper slices={get(sharedSlices, 'data.body', [])} />
    </>
  );
};
